import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerInitialState, basedDataReducer } from 'redux/base-reducer';

import { ProductionDevice } from '../types/eecs-production-device.types';

interface ProductionDevicesInitialState extends BaseDataReducerInitialState<ProductionDevice> {
  perPage: number;
  editingDevice: ProductionDevice | null;
}

const { initialState, AC, reducer, thunks } = basedDataReducer<ProductionDevice, ProductionDevicesInitialState>(
  'necs-production-devices',
);

const productionDevicesInitialState: ProductionDevicesInitialState = {
  ...initialState,
  perPage: 25,
  editingDevice: null,
  filters: {
    hasCertificates: 1,
  },
};

export const productionDevice = createSlice({
  name: 'productionDevice',
  initialState: productionDevicesInitialState,
  reducers: {
    setEditingProductionDevice: (state, action: PayloadAction<ProductionDevice | null>) => {
      state.editingDevice = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as ProductionDevicesInitialState, action);
    });
  },
});

export const ProductionDeviceAC = AC;
export const onProductionDeviceSort = thunks.onSort;
export const onProductionDeviceFilter = thunks.onFilter;
export const setProductionDeviceCurrentPage = AC.setCurrentPage;

export const { setEditingProductionDevice } = productionDevice.actions;
